import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Expulsion Post' },
    { value: 1, label: 'Notice of Potential Expulsion' },
    { value: 2, label: 'Notice of Expulsion' },
  ],
});
